import React from "react";
import doc from "../../assets/images/user.png";
import moment from "moment";
import { useNavigate } from "react-router-dom";

type AppointmentCardProps = { data: any };

export default function AppointmentCard({ data }: AppointmentCardProps) {
  const navigate = useNavigate();
  const displayName =
    data.patientName ?? data.user?.fullname ?? data.doctorName ?? "Appointment";
  const subtitle =
    data.doctor?.institution ?? data.user?.email ?? moment(data.date, "DD-MM-YYYY").format("Do MMM, YYYY");
  // "Report needed" wins the A/B comparison — kept permanently. The
  // "Report added" tag that used to show for the opposite case
  // (completed + doctor_report already present) was removed entirely,
  // per explicit decision — nothing marks that state anymore.
  const needsReport = data.status === "completed" && !data.doctor_report;

  return (
    <button
      type="button"
      onClick={() => navigate(`/appointments/${data.id}`)}
      className="relative flex w-full flex-col rounded-xl border border-slate-200/80 bg-white p-4 text-left shadow-card transition-all hover:border-primary-blue/30 hover:shadow-card-hover focus:outline-none focus:ring-2 focus:ring-primary-blue/40"
      aria-label={`View appointment ${displayName}, ${moment(data.date, "DD-MM-YYYY").format("Do MMMM YYYY")}`}
    >
      {/* E-commerce-style corner ribbon: bold, urgent, flush with the
          card's own corner (no rounding on the outer edges, so it reads
          as "attached" the way a sale tag sits on a product card). */}
      {needsReport && (
        <span className="absolute right-0 top-0 rounded-bl-lg rounded-tr-xl bg-red-600 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-white shadow-sm">
          Report needed
        </span>
      )}
      <div className="flex items-start gap-4">
        <div className="relative h-14 w-14 shrink-0 overflow-hidden rounded-xl bg-slate-100">
          <img
            src={data.user?.picture ?? data.doctor?.profile_image ?? doc}
            alt=""
            className="h-full w-full object-cover"
          />
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold text-slate-800">
            {displayName}
          </p>
          <p className="mt-0.5 truncate text-xs text-slate-500">{subtitle}</p>
        </div>
      </div>
      <div className="mt-4 flex items-center gap-2 border-t border-slate-100 pt-3">
        <span className="text-xs font-medium text-slate-600">
          {moment(data.date, "DD-MM-YYYY").format("Do MMM, YYYY")}
        </span>
        <span className="text-slate-300">·</span>
        <span className="text-xs text-slate-500">
          {data.startTime} – {data.endTime}
        </span>
      </div>
    </button>
  );
}
